import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tool-manager',
  templateUrl: './tool-manager.component.html',
  styleUrls: ['./tool-manager.component.less']
})
export class ToolManagerComponent implements OnInit {

  @Input() code: any; // code 0 备件只能查看，不能选择 code 1 备件可以查看 也可以被选中
  constructor() { }

  ngOnInit(): void {
  }

}
